<template>
	<div class="box box-default box-solid">
		<div @click="toogleBody($refs.boxBody)" class="box-header with-border">
			<div class="box-title">
				<b>{{ data.cod }}</b>
				{{ data.name }}
			</div>
			<div class="box-tools pull-right">
				<span class="badge">{{ data.tarefas.length }}</span>
				<!--  <span class="badge bg-blue">{{data.tarefas.length}}</span>
        <span class="badge bg-green">{{data.tarefas.length}}</span> -->
			</div>
		</div>

		<div ref="boxBody" class="box-body no-padding">
			<table class="table table-hover table-condensed">
				<tbody>
					<item-tarefa
						v-for="(tarefa, id) in data.tarefas"
						:key="id"
						:data="tarefa"
					/>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	import ItemTarefa from './item-tarefa.vue';
	import ToogleFunction from '../js/ToogleFunction.mixin.js';
	export default {
		props: ['data'],
		components: { ItemTarefa },
		mixins: [ToogleFunction],
		mounted() {
			this.toogleBody(this.$refs.boxBody, 0);
		},
	};
</script>
<style scoped>
	.box-header {
		cursor: pointer;
	}
	.box-body {
		padding: 0px !important;
		width: 100% !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/ModeAgroup/components/item-servico.vue